import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0B0A0C]">
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md glass border border-[#D4AF37]/20 rounded-2xl p-8 sm:p-10"
      >
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-full border border-[#D4AF37]/40 flex items-center justify-center mb-5">
            <Lock className="w-6 h-6 text-[#D4AF37]" />
          </div>
          <span className="font-display text-2xl gold-text tracking-[0.15em]">AFRODITE</span>
          <p className="overline mt-2">Area Riservata</p>
        </div>

        {error && <div className="mb-5 p-3 rounded-lg bg-[#7A1426]/25 border border-[#7A1426] text-sm text-[#F3E5AB] text-center">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs text-[#A39E9B] mb-1.5 block">Email</label>
            <input
              data-testid="admin-login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0B0A0C] border border-[#D4AF37]/20 text-[#FBF8F5] focus:border-[#D4AF37] outline-none transition-colors"
              placeholder="afroditeclubprive@gmail.com"
            />
          </div>
          <div>
            <label className="text-xs text-[#A39E9B] mb-1.5 block">Password</label>
            <input
              data-testid="admin-login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0B0A0C] border border-[#D4AF37]/20 text-[#FBF8F5] focus:border-[#D4AF37] outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit-btn" type="submit" disabled={loading}
            className="w-full py-3.5 rounded-full bg-[#7A1426] hover:bg-[#941B30] text-[#FBF8F5] font-semibold transition-colors border border-[#D4AF37]/30 disabled:opacity-60"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
        </form>

        <div className="mt-6 flex justify-between text-xs">
          <Link to="/forgot-password" className="text-[#A39E9B] hover:text-[#D4AF37]">Password dimenticata?</Link>
          <Link to="/" className="text-[#A39E9B] hover:text-[#D4AF37]">Torna al sito</Link>
        </div>
      </motion.div>
    </div>
  );
}
